import isEmpty from 'lodash.isempty';

export const generateFilterUrl = (filters) => {
    let mappings = {},
        params = [],
        url = '';
    if (!isEmpty(filters)) {
        Object.keys(filters).forEach((filterKey) => {
            if (filters?.[filterKey] || filters?.[filterKey] === 0)
                mappings = {...mappings, ...filters};
            else {
                delete filters[filterKey];
                mappings = {...filters};
            }
            if (Array.isArray(filters?.[filterKey])) {
                if (isEmpty(filters?.[filterKey])) delete filters[filterKey];
                mappings = {...filters};
            }
        });
        params = createQueryParamUrl(mappings).join('');
        url = params;
    }
    return url;
};
export const createQueryParamUrl = (filterKeys) => {
    let params = [];
    try {
        let filterKeysArray = Object.keys(filterKeys);
        filterKeysArray.forEach((key, index) => {
            if (filterKeys[key] !== null) {
                params.push(
                    `${key}=${filterKeys[key]}${
                        index !== filterKeysArray?.length - 1 ? '&' : ''
                    }`,
                );
            }
        });
    } catch (e) {}
    return params;
};
export const findRouteDefaultPath = (uiPageMenu, path) => {
    const pagesMapping = {
        home: '/landingpage',
        macro: '/macro',
        industry: '/screener/industry',
        etf: '/etf',
        screener: '/screener',
        corporate: '/corporateaccess',
        followAnalysts: '/analysts',
        watchlist: '/watchlist',
        learn: '/learn',
    };
    const allTabs = [];
    let pathname = path;
    let search = '';
    if (typeof path === 'object') {
        pathname = path?.pathname;
        search = path?.search;
    }

    if (path) {
        const availablePages = [];
        for (let key in pagesMapping) {
            allTabs.push(pagesMapping[key]);
            if (uiPageMenu?.[key]) {
                availablePages.push(pagesMapping[key]);
            }
        }
        if (pathname === '/screener' && search) {
            return path;
        }
        if (availablePages.filter((v) => pathname.startsWith(v)).length > 0) {
            return path;
        }
        if (
            availablePages.length > 0 &&
            allTabs.filter((v) => pathname.startsWith(v)).length > 0
        ) {
            return availablePages[0];
        } else {
            return path;
        }
    }
    return path;
};
